import React, { useEffect, useRef, useState } from "react";
import { TableListPage } from "Components/TableListPage/MyTable";
import { Button, Form, Space } from "antd";
import { UnorderedListOutlined } from "@ant-design/icons";
import { MyPagination } from "Components/MyPagination/MyPagination";
import { DrawerWrapper } from "Components/DrawerWrapper/DrawerWrapper";
import { CreateUserForm } from "./components/CreateUserForm/CreateUserForm";
import { useDispatch, useSelector } from "react-redux";
import {
  createUserThunk,
  getAllRolesThunk,
  getAllUsersThunk,
  selectUser,
  updateUserThunk,
} from "AppStore/Slices/UserSlice/UserSlice";
import { UpdateUserForm } from "./components/UpdateUserForm/UpdateUserForm";
export const UsersTableWrapper = () => {
  const { total, currentPage, usersList, allRoles, isLoading } =
    useSelector(selectUser);
  const [checkedUserToUpdate, setCheckedUserToUpdate] = useState(null);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [formCreate] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const timeoutId = useRef();
  const handleCreate = async () => {
    try {
      const values = await formCreate.validateFields();
      dispatch(createUserThunk({ ...values }));
      setOpen(false);
      formCreate.resetFields();
    } catch (err) {
      return err;
    }
  };
  const handleEdit = async () => {
    try {
      const values = await formEdit.validateFields();

      dispatch(
        updateUserThunk({
          ...values,
          id: checkedUserToUpdate,
        }),
      );

      setCheckedUserToUpdate(null);
      formEdit.resetFields();
    } catch (err) {
      return err;
    }
  };
  const columns = [
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Ім'я",
      dataIndex: "name",
    },

    {
      title: "Дії",
      render: (_, record) => (
        <Space>
          <Button
            icon={<UnorderedListOutlined />}
            onClick={() => {
              setCheckedUserToUpdate(record.id);
            }}
          />
        </Space>
      ),
    },
  ];
  useEffect(() => {
    clearTimeout(timeoutId.current);
    if (searchValue) {
      timeoutId.current = setTimeout(() => {
        if (page === 1) {
          dispatch(getAllUsersThunk({ searchValue }));
        } else {
          dispatch(getAllUsersThunk({ page, searchValue }));
        }
      }, 500);
      return;
    } else {
      if (page === 1) {
        Promise.all([
          dispatch(getAllRolesThunk()),
          dispatch(getAllUsersThunk({ page })),
        ]);
      } else {
        dispatch(getAllUsersThunk({ page }));
      }
    }
  }, [page, searchValue]);

  return (
    <>
      <TableListPage
        isLoading={isLoading}
        mainTitle={"Всі користувачі"}
        data={usersList}
        columns={columns}
        openDrawer={setOpen}
        setSearch={setSearchValue}
        search={searchValue}
      />
      <DrawerWrapper
        title="Створення користувача"
        open={open}
        setOpen={() => setOpen(false)}
        // handleCreate={handleCreate}
        showCreateBtn={true}
        form={formCreate}
      >
        <CreateUserForm
          roles={allRoles}
          form={formCreate}
          onFinish={handleCreate}
        />
      </DrawerWrapper>
      <DrawerWrapper
        title="Редагування користувача"
        setOpen={() => setCheckedUserToUpdate(null)}
        // handleCreate={handleEdit}
        open={Boolean(checkedUserToUpdate)}
        showEditBtn
        form={formEdit}
      >
        <UpdateUserForm
          form={formEdit}
          roles={allRoles}
          userId={checkedUserToUpdate}
          onFinish={handleEdit}
        />
      </DrawerWrapper>
      <MyPagination
        limit={10}
        totalItems={total}
        isLoading={isLoading}
        currentPage={currentPage}
        changePage={setPage}
      />
    </>
  );
};
